export default __webpack_public_path__ + "static/BCParks_Primary_Reversed-cropped-0080416cb5f347c8e7c33f32739f17ca.svg";